import renderThreats from './renderThreats';

export default class PeriodSwitcher {
  static removeActive() {
    $('.period__btn').removeClass('active');
  }

  static makeActive($elem) {
    $elem.addClass('active');
  }

  static init() {
    $('.period__btn').on('click', async (event) => {
      const $elem = $(event.target);

      PeriodSwitcher.removeActive();
      PeriodSwitcher.makeActive($elem);

      const searchQuery = $('#search').val();

      if (searchQuery) {
        $('#search').trigger('keyup');
        return;
      }

      renderThreats();
    });
  }
}
